"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SEO = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = require("react-helmet");

var initialize = function initialize(options) {
  if (!options) {
    console.warn('Options cannot be `null` for function initialize()');
    return;
  }

  window.BHGSEO = (0, _objectSpread2.default)({}, options);
};

var SEO = function SEO(props) {
  var title = props.title,
      slug = props.slug,
      description = props.description,
      image = props.image,
      type = props.type,
      locale = props.locale,
      children = props.children;

  var _ref = window.BHGSEO || {},
      url = _ref.url,
      creator = _ref.creator,
      siteName = _ref.siteName;

  return /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("meta", {
    name: "description",
    content: description
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "robots",
    content: "max-snippet:-1, max-image-preview:large, max-video-preview:-1"
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "canonical",
    href: url + slug
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:locale",
    content: locale
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:type",
    content: type
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:title",
    content: title
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:description",
    content: description
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:url",
    content: url + slug
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:site_name",
    content: siteName
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:image",
    content: image
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:image:secure_url",
    content: image
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:description",
    content: description
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:title",
    content: title
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:site",
    content: "@" + creator
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:image",
    content: image
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "twitter:creator",
    content: "@" + creator
  }), children);
};

exports.SEO = SEO;
SEO.defaultProps = {
  title: '',
  slug: '/',
  description: '',
  image: '',
  locale: 'en_GB',
  type: 'website'
};
var _default = {
  initialize: initialize
};
exports.default = _default;